import { Text } from '@enechain/ecloud-designsystem'

/**
 * 必須項目のラベルに添える `*` (design 8080 の `.req` 準拠)。
 *
 * `FieldRoot required` は a11y 上の必須性 (`aria-required`) を立てるだけで**見た目に
 * 出ない**ため、 目で必須が分かるようにこれをラベルへ足す。
 *
 * ## 読み取り専用の時は出さない
 *
 * 入力できない状態で `*` を出しても「入れろ」 という指示にしかならない。 呼び出し側で
 * `{!readOnly && <RequiredMark />}` の形にする (= 表示専用モードを持つ画面のみ)。
 *
 * ## 置き場所
 *
 * 個別作成モーダルと発注主体セレクタ (時間前入札とも共有) の 2 箇所から使うため
 * 共通化した。 なお `WorkflowCases/components/CreateWorkflowCasesDialog.tsx` にも
 * 同名のローカル実装が残っている (太字の有無だけ違う)。 別画面のため本 component へ
 * 寄せる判断は保留しており、 統一するなら別途。
 */
export const RequiredMark = (): React.ReactElement => (
  <Text as="span" marginLeft={1} color="Text.negativeMid" fontWeight="bold">
    *
  </Text>
)
